import React, { Component } from 'react';
// utils
import debounce from 'lodash.debounce';
// redux
import { connect } from 'react-redux';
import { setPromptsFilter } from '../../../redux/reducers/journals';
// components
import Input from '../../../components/Input/Input';
// styles
import styles from './FilterPrompts.mod.css';
import classnames from 'classnames/bind';

let cn = classnames.bind(styles);

class FilterPrompts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: ''
    };
    this.debouncedFilterPrompts = debounce(this.handleFilterPrompts, 300);
  }

  handleFilterPrompts = () => {
    this.props.setPromptsFilter(this.state.title);
  };

  onTitleChange = ({ target: { value } }) => {
    this.setState({ title: value }, this.debouncedFilterPrompts);
  };

  render() {
    const { title } = this.state;
    const { className, userColor } = this.props;
    return (
      <div className={cn(className, 'wrapper')}>
        <Input
          wrapperClassName={cn('filter', 'input-wrapper')}
          color={userColor}
          placeholder="Search"
          name="title"
          value={title}
          onChange={this.onTitleChange}
        />
      </div>
    );
  }
}

export default connect(
  null,
  { setPromptsFilter }
)(FilterPrompts);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/FilterPrompts.jsx